import React from 'react';

import initReactApp from 'dpl/util/initReactApp';
import MobileBuyerQuotesSliderContainer from 'dpl/good_dog_pay/containers/MobileBuyerQuotesSliderContainer';
import BreederJoinTrustSection from 'dpl/common/components/TrustSection';
import FaqsSectionContainer from 'dpl/join_as_breeder/containers/FaqsSectionContainer';

initReactApp({
  MobileBuyerQuotesSliderContainer,
  BreederJoinTrustSection,
  /* eslint-disable react/display-name */
  FaqsSectionContainer: () => <FaqsSectionContainer withHelpNumber={false} />
  /* eslint-enable react/display-name */
});
